import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/Home.vue')
    },
    {
      path: '/exam-prep',
      name: 'ExamPrep',
      component: () => import('../views/ExamPrep.vue')
    },
    {
      path: '/video-resources',
      name: 'VideoResources',
      component: () => import('../views/VideoResources.vue')
    },
    {
      path: '/question-bank',
      name: 'QuestionBank',
      component: () => import('../views/QuestionBank.vue')
    },
    {
      path: '/others',
      name: 'Others',
      component: () => import('../views/Others.vue')
    },
    {
      path: '/task',
      name: 'Task',
      component: () => import('../views/task.vue')
    },
    {
      path: '/resource-detail',
      name: 'ResourceDetail',
      component: () => import('../views/ResourceDetail.vue')
    },

    {
      path: '*',
      redirect: '/404',  // 假设您有一个404组件
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js